import styled from "styled-components";

export const ActionGroup = styled.div`
  display: flex;

  & > * {
    margin-left: 0.75rem;
  }
`;
